import {t} from '../../../common/getTranslations';
import {twMerge} from '../../../common/twMerge';
import {TicketKind} from '../../../graphql/generated/types';
import {Button} from '../../atoms/Button/Button';
import {ButtonColorScheme, ButtonSize} from '../../atoms/Button/Button.enum';
import {Image} from '../../atoms/Image/Image';
import {Text} from '../../atoms/Text/Text';
import {ThumbnailRatio} from '../../molecules/ThumbnailWithBadges/ThumbnailRatio.constant';
import {ThumbnailType} from '../../molecules/ThumbnailWithBadges/ThumbnailType.enum';
import {PromotionCardType} from './constants';
import {PromotionCardProps} from './PromotionCardProps.interface';

export function PromotionCard({
  title,
  thumbnail,
  ticketType,
  ticketCount,
  received,
  promotionText,
  cardType,
  onClickButton,
  className,
  ...props
}: PromotionCardProps) {
  return (
    <div
      className={twMerge(
        'relative w-200pxr cursor-pointer overflow-hidden inner-line-static-transparent-black-05 inner-line-rounded-3px inner-line-0.5px',
        className
      )}
      {...props}
    >
      <Image
        src={thumbnail}
        ratio={ThumbnailRatio[ThumbnailType.Promotion]}
        alt="썸네일 이미지"
      />
      <div
        className="absolute bottom-0 flex h-200pxr w-full flex-col justify-end p-16pxr"
        style={{
          background:
            'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.9) 100%)',
        }}
      >
        <div>
          <Text className="font-medium1-bold text-ellipsis text-static-mono-10 line-clamp-1">
            {title}
          </Text>
        </div>
        {cardType === PromotionCardType.Gift && (
          <div className="mt-8pxr flex flex-row items-center justify-between">
            <Text className="font-small2 text-static-point-yellow">
              {ticketType === TicketKind.Own ? '소장권' : '대여권'}{' '}
              {ticketCount}장
            </Text>
            {received && (
              <Button
                size={ButtonSize.Small}
                colorScheme={ButtonColorScheme['3rd']}
                onClick={onClickButton}
              >
                {t('giftbox_gift_view')}
              </Button>
            )}
            {!received && (
              <Button
                size={ButtonSize.Small}
                colorScheme={ButtonColorScheme['1st']}
                onClick={onClickButton}
              >
                {t('giftbox_gift_get')}
              </Button>
            )}
          </div>
        )}
        {cardType !== PromotionCardType.Gift && promotionText && (
          <div className="mt-11pxr flex flex-row items-center justify-between">
            <Text className="font-small2 text-ellipsis text-static-mono-40 line-clamp-1">
              {promotionText}
            </Text>
          </div>
        )}
      </div>
    </div>
  );
}
